import { filter, prop } from 'ramda';
import { createSelector } from 'reselect';

import { errorsToReport, NAME } from './constants';

const getRoot = prop(NAME);

export const getErrors = createSelector(
	getRoot,
	filter((e) => errorsToReport.includes(e.status)),
);
